import type { ExpectedCloseV2CanonicalForecastRow } from "./localExpectedCloseForecast";

/** Display-only compatibility for legacy charts. No model calculation belongs here. */
export function canonicalForecastRows(
  rows: readonly (ExpectedCloseV2CanonicalForecastRow & { expected_close_v2: number | null })[], historical: boolean, accumulated: boolean,
) {
  let won = 0;
  return rows.map(row => {
    if (row.is_context) won = 0;
    won += Number(row.won ?? 0);
    const value = historical ? (accumulated ? won : Number(row.won ?? 0)) : row.expected_close_v2;
    // A transport/model availability failure must not masquerade as V1 or zero.
    if (value === null || !Number.isFinite(value)) throw new Error("Forecast data is unavailable");
    if (row.is_context) won = 0;
    return { ...row, total_minus_risk: value };
  });
}
